import { useNavigate } from "react-router-dom";
import MUITable from "../../../../Common/MUITable";
import { TableLoader } from "../../../../Common/ShimmerLoader";
import { useEffect } from "react";
import { AttendanceFilterForm } from "../AttendanceSummaryReport/./AttendanceFilterForm"
import { useAttendanceStore } from "./store/useAttendanceStore";

const AttendanceSummaryReport = () => {
  const { fetchSupportingStaffDetails } = useAttendanceStore();
  const navigate = useNavigate();
  const {
    isFetchingAttendanceReport,
    attendanceReport, // Get attendance data
    fetchAttendanceReport, // Fetch API data
    fetchZoneLevelDetails,
  } = useAttendanceStore();
  const filters = JSON.parse(localStorage.getItem("attendance-summary-filters"));

  const attendanceSummaryHeaderColumns = [
    {
      label: "Zone",
      field: "zone",
      render: (row) => {
        // Check if the row is the total row
        if (row.zone === "Total") {
          return <div>{row.zone}</div>; // Display plain text for total row
        }

        return (
          <div
            style={{ cursor: "pointer", color: "blue" }}
            onClick={() => {
              const params = {
                fromDate: filters.fromDate,
                toDate: filters.toDate,
                zoneId: row.zoneId,
              };
              if (row.zone === "Supporting Staff") {
                fetchSupportingStaffDetails({
                  fromDate: filters.fromDate,
                  toDate: filters.toDate,
                });
                navigate("/supporting-staff-drill-down", { state: params });
              } else {
                fetchZoneLevelDetails(params);
                navigate("/zone-level-drill-down", { state: params });
              }
            }}
          >
            {row.zone}
          </div>
        );
      },
    },
    {
      label: "Planned Attendance",
      field: "plannedAttendance",
      render: (row) => row.plannedAttendance,
    },
    {
      label: "Biometric Attendance",
      field: "biometricAttendance",
      render: (row) => row.biometricAttendance,
    },
    {
      label: "Forced Attendance",
      field: "forcedAttendance",
      render: (row) => row.forcedAttendance,
    },
    {
      label: "BA + FA",
      field: "bA_FA",
      render: (row) => row.bA_FA,
    },
    {
      label: "Shortfall",
      field: "shortfall",
      render: (row) => row.shortfall,
    },
    {
      label: "Attendance Percentage",
      field: "attendancePercentage",
      render: (row) => {
        if (row.zone === "Total") {
          if (row.shortfall == "0" && row.plannedAttendance == "0") {
            return "0%"
          } else {
            if (row.shortfall == "0") {
              return "100%"
            } else {
              return Math.round((100 - (row.shortfall / row.plannedAttendance) * 100)* 100) / 100 + "%"
            }
          }
        } else {
          return row.attendancePercentage + "%"
        }
      }
    }
  ];

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 className="text-start mb-3">Attendance Summary Report</h4>
            <div className="page-header text-start">
              <div className="card">
                <div className="card-body">
                  <AttendanceFilterForm />
                  <MUITable
                    hasTotalRow
                    needSRNumber
                    columns={attendanceSummaryHeaderColumns}
                    rows={attendanceReport} // Pass data here
                    tableHeight={500}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceSummaryReport;